// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Header-HeaderTitle-module--cls1--3kP_L","cls2":"Header-HeaderTitle-module--cls2--_dHmN Header-HeaderTitle-module--cls1--3kP_L"};